import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab-validation"
export default class extends Controller {
  connect() {
    this.element.addEventListener("invalid", this.handleInvalid.bind(this), true)
  }

  disconnect() {
    this.element.removeEventListener("invalid", this.handleInvalid.bind(this), true)
  }

  handleInvalid(event) {
    const field = event.target
    const tabContent = field.closest("[data-tabs-target='content']")
    if (!tabContent) return

    const index = tabContent.dataset.index
    const tab = this.element.querySelector(`[data-tabs-target='tab'][data-index='${index}']`)
    if (tab) tab.click()
  }
}